import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';

export default function ComprasTable({ compras, onEdit, onAnular }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Fecha</TableCell>
          <TableCell>Concepto</TableCell>
          <TableCell>Monto</TableCell>
          <TableCell>Estado</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {compras.map(c => (
          <TableRow
            key={c.id}
            sx={{
              textDecoration: c.estado === 'ANULADA' ? 'line-through' : 'none',
              opacity: c.estado === 'ANULADA' ? 0.5 : 1
            }}
          >
            <TableCell>{c.fecha}</TableCell>
            <TableCell>{c.concepto}</TableCell>
            <TableCell>{c.monto}</TableCell>
            <TableCell>{c.estado}</TableCell>
            <TableCell>
              <IconButton onClick={() => onEdit(c)}>
                <EditIcon />
              </IconButton>
              {c.estado === 'ACTIVA' && (
                <IconButton
                  color="error"
                  onClick={() => {
                    const motivo = prompt('Motivo de anulación');
                    if (motivo) onAnular(c.id, motivo);
                  }}
                >
                  <CancelIcon />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
